import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, filter, switchMap } from 'rxjs';
export const DEFAULT_UNAUTHINTERCEPTOR = new InjectionToken<boolean>('defines if DISABLE_UNAUTHINTERCEPTOR is enable by default.',{
  factory: () => true // default true per retrocompatibilità
});
export const DISABLE_UNAUTHINTERCEPTOR = new HttpContextToken<boolean>(() => false);
export const UnauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const authsvc = inject(AuthService);
  const defunau = inject(DEFAULT_UNAUTHINTERCEPTOR);
  return next(req).pipe(
    catchError(error => {
      if (error.status !== 401 || req.context.get(DISABLE_UNAUTHINTERCEPTOR) || defunau) throw error;
      console.log(`Intercepted ${req.method} ${req.url} with status 401`);
      return authsvc.logout().pipe(
        switchMap(() => authsvc.requestLogin()),
        filter(a => a !== null),
        switchMap(() => next(req.clone()))
      );
    })
  );
};
